/**
 * SP: hides the countdown surfaces the moment their end time passes,
 * client-side. The 21/12/4-day visibility tiers are server-rendered
 * (sections/sp-announcement-timer.liquid + snippets/sp-product-countdown.liquid),
 * which leaves two gaps this closes:
 *   1. pages rendered in the final minute (end is 23:59, the roll to next
 *      month happens at midnight) would show a zeroed timer;
 *   2. tabs already open when the cutoff passes sit at zero until reload.
 * The vendor countdown-timer.js just stops at zero (clearInterval) — it
 * never hides anything.
 *
 * Loaded from both countdown surfaces; the flag guards double-execution
 * when both render on one page.
 */
(function () {
  'use strict';
  if (window.__spCountdownExpire) return;
  window.__spCountdownExpire = true;

  function check() {
    document.querySelectorAll('countdown-timer[data-end-date]').forEach(function (t) {
      var box = t.closest('.sp-ann-timer, .sp-pdp-countdown');
      if (!box || box.hasAttribute('data-sp-expired')) return;
      var end = new Date(t.dataset.endDate).getTime();
      if (!end || Date.now() < end) return;
      box.setAttribute('data-sp-expired', '');
      box.style.display = 'none';
    });
  }

  check();
  // 15s poll is enough — the visible timer only matters to the minute, and
  // visibilitychange catches a tab re-focused hours/days later immediately.
  setInterval(check, 15000);
  document.addEventListener('visibilitychange', check);
})();
